<div class="app-wrap" *ngIf="pageLoaded">
  <component-menu-bar #menuBar [exerciseBook]="exerciseBook" [assetsRoute]="assetsRoute" [userAuthority]="userAuthority" [showMentorRedDot]="showMentorRedDot && !isShowMentorGuide" *ngIf="showMenuBar&&loadFinished" [isHaveTools]="isHaveTools" (showGDPR)="showGDPR()" (logout)="showComponentTip()" (mentorEntered)="onMentorEntered()" (menuBarClose)="onMenuBarCloseDuringDebug()"></component-menu-bar>
  <router-outlet></router-outlet>
  <div id="loadingScreen" *ngIf="loading">
    <div class="loading-wrap">
      <img src="{{assetsRoute}}/picture/Loading.gif" alt="">
      <div class="error-text" >玩命加载中...</div>
      <!--<div class="loading-process">-->
        <!--<div class="process-gif"></div>-->
      <!--</div>-->
      <!--<div class="error-text" >玩命加载中，请稍后...</div>-->
    </div>
  </div>
</div>


<app-guide *ngIf="showMenuBar && isHaveTools && isShowGuide && !isShowMentorGuide && !isOnlyCamp && startAsking" [pageLoaded]="pageLoaded" (outPutMenuClick)="menuBar.showOrCloseFullPage()" (outPutToolsClick)="goTools()"></app-guide>
<app-mentor-guide *ngIf="showMenuBar && isShowMentorGuide && !isOnlyCamp && startAsking" [pageLoaded]="pageLoaded" [assetsRoute]="assetsRoute" (outPutMenuClick)="onMentorMenuClick()"></app-mentor-guide>
<app-gdpr *ngIf="isShowGDPR" [gdprStatus]="gdprStatus" (closeGDPR)="closeGDPR()"></app-gdpr>
<app-com-tip *ngIf="isShowTip" (onCancel)="logout()" (onSure)="closeComponentTip()" [type]="'tip'" [desText]="'确认要退出登录么？'" [cancelText]="'确定'" [sureText]="'取消'" ></app-com-tip>
<app-heart-beat [browserPlatformLocation]="browserPlatformLocation" *ngIf="isStartHeatBeat"></app-heart-beat>
<app-user-available-asking *ngIf="startAsking" (outPutHeartBeatStatus)="getHeartBeatStatusByAsking($event)"></app-user-available-asking>



// WEBPACK FOOTER //
// ./src/app/app.component.html